import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  private casNumberRegex = "[0-9]{1,7}-[0-9]{2}-[0-9]{1}";
  private egIndexNumberRegex = "[0-9]{3}-[0-9]{3}-[0-9]{2}-([0-9]|X){1}";
  private egNumberRegex = "[0-9]{3}-[0-9]{3}-[0-9]{1}";

  isNumeric = (value: string): boolean => {
    return !new RegExp(/[^\d]/g).test(value.trim());
  }

  isCasNumber = (value: string): boolean => {
    const regex = new RegExp(this.casNumberRegex);
    return regex.test(value);
  };

  isEgNumber = (value: string): boolean => {
    const egNumRegex = new RegExp(this.egNumberRegex);
    const egIndexNumRegex = new RegExp(this.egIndexNumberRegex);
    return egNumRegex.test(value) || egIndexNumRegex.test(value);
  };
}
